import React from 'react';

export default () => (
  <svg width="12" height="15" viewBox="0 0 12 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 0V15L11.7857 7.5L0 0Z" fill="currentColor" />
  </svg>
);
